import { Avatar } from "monday-ui-react-core";
import styled from "styled-components";

import { IMMEDIATE_SHOW_DELAY } from "@/components/MondayBasics/MondayWorkspaceIcon/constants/tooltipConstant";

type WorkspaceIconProps = {
  workspaceName: string;
  color?: string;
  icon?: string | null;
  size?: number;
};

const getFirstLetter = (text: string) => text[0];

export const WorkspaceIcon: React.FC<WorkspaceIconProps> = ({ workspaceName, icon, color, size }) => {
  const avatarType = icon ? Avatar.types.IMG : Avatar.types.TEXT;

  return (
    <AvatarWrapper>
      <Avatar
        size={Avatar.sizes.SMALL}
        tooltipProps={{
          containerSelector: "body",
          children: null,
          content: workspaceName,
          immediateShowDelay: IMMEDIATE_SHOW_DELAY,
        }}
        src={icon}
        withoutBorder={true}
        text={getFirstLetter(workspaceName)}
        type={avatarType}
        customBackgroundColor={color}
        customSize={size}
        square
        tabIndex={-1}
      />
    </AvatarWrapper>
  );
};

const AvatarWrapper = styled.div``;
